export default {
    request (action = null, data = {}) {
        return new Promise((resolve, reject) => {

            let request = new XMLHttpRequest();

            request.open('POST', adminAjax, true);

            request.onload = function() {
                if (this.status >= 200 && this.status < 400) resolve(JSON.parse(this.response))
                else reject(new Error('An error occured, data response has failed'))
            }

            request.onerror = function() {
                reject(new Error('An error occured, data response has failed'))
            }

            const formData = new FormData();
            formData.append('action', action)

            for (const [key, value] of Object.entries(data)) {
                formData.append(key, value)
            }

            request.send(formData);

        })
    }
}
